export default __webpack_public_path__ + "static/media/kespanol.d8245f0d.png";